import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const NotificationTemplateList = Loadable(
  lazy(() => import("features/notification/templates/components/List"))
);
const NotificationTemplatePage = Loadable(
  lazy(() => import("features/notification/templates/components/Page"))
);

const routes = {
  path: "templates",
  children: [
    { path: "", element: <NotificationTemplateList /> },
    { path: "add", element: <NotificationTemplatePage /> },
    { path: "edit/:notificationID?", element: <NotificationTemplatePage /> },
  ],
};

export default routes;
